/* NUF: Reliable Shoptimized AJAX drawer checkout (Sep 2026, bounded wait)
 * Keeps Shopify's native cart POST contract while bypassing Shoptimized's
 * private isUpdating flag, which can remain stuck after a failed cart change.
 */
(function () {
  'use strict';

  if (window.__nufCartCheckoutRecoveryLoaded) return;
  window.__nufCartCheckoutRecoveryLoaded = true;

  var pendingMutations = 0;
  var lastMutationStartedAt = 0;
  var queuedCheckout = false;
  var queuedForm = null;
  var submitting = false;
  var checkoutTimer = null;
  var lastDrawerCheckout = null;
  var clickSequence = 0;
  var MAX_MUTATION_WAIT = 1200;
  var STALE_MUTATION_AGE = 2000;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawerForm() {
    return document.querySelector('#CartDrawer form.ajaxcart');
  }

  function drawerCheckoutButton(node) {
    if (!node || !node.closest) return null;
    return node.closest('#CartDrawer form.ajaxcart button[name="checkout"]');
  }

  function mutationStarted() {
    pendingMutations += 1;
    lastMutationStartedAt = Date.now();
  }

  function mutationFinished() {
    pendingMutations = Math.max(0, pendingMutations - 1);
    window.setTimeout(flushCheckout, 0);
  }

  function hasActiveMutation() {
    if (pendingMutations > 0 && Date.now() - lastMutationStartedAt > STALE_MUTATION_AGE) {
      pendingMutations = 0;
    }
    return pendingMutations > 0;
  }

  function submitNativeCart(form) {
    if (submitting) return;

    var currentForm = form && form.isConnected ? form : drawerForm();
    if (!currentForm) {
      window.location.assign(routesRoot() + 'cart');
      return;
    }

    submitting = true;
    window.clearTimeout(checkoutTimer);

    var checkoutInput = currentForm.querySelector('input[data-nuf-checkout-submit]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      checkoutInput.setAttribute('data-nuf-checkout-submit', 'true');
      currentForm.appendChild(checkoutInput);
    }

    currentForm.action = routesRoot() + 'cart';
    currentForm.method = 'post';

    /* Native prototype submission bypasses Shoptimized's delegated submit
       blocker while preserving updates[], note, and name=checkout. */
    window.HTMLFormElement.prototype.submit.call(currentForm);
  }

  function flushCheckout() {
    if (!queuedCheckout || submitting || hasActiveMutation()) return;
    queuedCheckout = false;
    submitNativeCart(queuedForm);
  }

  function queueCheckout(form) {
    if (submitting || queuedCheckout) return;

    queuedCheckout = true;
    queuedForm = form;

    if (!hasActiveMutation()) {
      flushCheckout();
      return;
    }

    /* Shoptimized does not reliably emit every completion event. Never leave
       Checkout waiting on its internal state: the native cart POST carries the
       current quantities and note itself. */
    checkoutTimer = window.setTimeout(function () {
      pendingMutations = 0;
      flushCheckout();
    }, MAX_MUTATION_WAIT);
  }

  /* Record intent in capture phase. The zero-delay fallback handles cases
     where another script suppresses the form submit event. */
  document.addEventListener('click', function (event) {
    var button = drawerCheckoutButton(event.target);
    if (!button) return;

    lastDrawerCheckout = button;
    clickSequence += 1;
    var thisClick = clickSequence;

    window.setTimeout(function () {
      if (thisClick !== clickSequence || submitting || queuedCheckout) return;
      queueCheckout(button.form || drawerForm());
    }, 0);
  }, true);

  /* Capture before Shoptimized's delegated body handler can cancel checkout
     while its private isUpdating flag is stuck. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('#CartDrawer form.ajaxcart')) return;

    var submitter = event.submitter || lastDrawerCheckout;
    if (!submitter || submitter.name !== 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    clickSequence += 1;
    queueCheckout(form);
  }, true);

  function bindCartLifecycle() {
    if (!window.jQuery || !document.body) {
      window.setTimeout(bindCartLifecycle, 50);
      return;
    }

    var $body = window.jQuery(document.body);
    $body.off('.nufCheckoutRecovery');

    $body.on('beforeChangeItem.ajaxCart.nufCheckoutRecovery', mutationStarted);
    $body.on('completeChangeItem.ajaxCart.nufCheckoutRecovery', mutationFinished);
    $body.on('errorChangeItem.ajaxCart.nufCheckoutRecovery', mutationFinished);
    $body.on('beforeUpdateCartNote.ajaxCart.nufCheckoutRecovery', mutationStarted);
    $body.on('completeUpdateCartNote.ajaxCart.nufCheckoutRecovery', mutationFinished);
    $body.on('errorUpdateCartNote.ajaxCart.nufCheckoutRecovery', mutationFinished);

    /* afterCartLoad is useful as an extra signal, but no longer gates checkout. */
    $body.on('afterCartLoad.ajaxCart.nufCheckoutRecovery', function () {
      window.setTimeout(flushCheckout, 0);
    });
  }

  bindCartLifecycle();
}());
